var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"google-ad",attrs:{"id":("div-" + _vm.id)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }